// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Day Detail Modal Styles */
.day-detail-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.day-detail-modal .ant-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eaedf3;
  background-color: #f8f9fa;
}

.day-detail-modal .ant-modal-body {
  padding: 0;
}

.day-detail-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.day-detail-modal .ant-modal-close-x {
  width: 32px;
  height: 32px;
  line-height: 32px;
}

/* Modal Title */
.day-modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.day-date {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-right: 12px;
}

.day-pod {
  font-size: 14px;
  color: #666666;
  background-color: #f0f7ff;
  padding: 4px 12px;
  border-radius: 16px;
  display: inline-block;
}

.day-summary {
  display: flex;
  gap: 16px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.summary-label {
  font-size: 14px;
  color: #666666;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

/* Modal Content */
.modal-content {
  padding: 24px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
  border-radius: 8px;
}

.export-button {
  border-radius: 8px;
  background-color: #f0f7ff;
  color: #3B82F6;
  border-color: #d0e1fd;
}

.export-button:hover {
  background-color: #e0efff;
  color: #2563eb;
  border-color: #b0d0fc;
}

/* Table Styles */
.client-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.client-table .ant-table-thead > tr > th {
  background-color: #f8f9fa;
  color: #333333;
  font-weight: 600;
}

.client-row-day:hover > td {
  background-color: #f0f7ff !important;
}

.case-count {
  font-weight: 600;
  color: #3B82F6;
}

.amount {
  font-weight: 600;
  color: #10B981;
}

.summary-row {
  background-color: #f8f9fa;
  font-weight: 600;
}

.summary-row td {
  padding: 12px 16px !important;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  gap: 16px;
}

.loading-container p {
  color: #666666;
  margin-top: 12px;
}

/* Empty State */
.empty-data {
  padding: 60px 0;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .day-modal-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .day-summary {
    width: 100%;
    justify-content: flex-start;
  }
  
  .modal-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .search-input {
    width: 100%;
  }
}

.modality-breakdown {
    min-width: 300px;
    padding: 12px;
}

.modality-section {
    margin-bottom: 16px;
}

.modality-section:last-child {
    margin-bottom: 0;
}

.modality-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #eaedf3;
    margin-bottom: 8px;
}

.discount-splits {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.discount-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    font-size: 13px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
}

.discount-row span:last-child {
    text-align: right;
    color: #2563eb;
} `, "",{"version":3,"sources":["webpack://./src/components/Contribution/Incentive/DayDetailModal.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":["/* Day Detail Modal Styles */\n.day-detail-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.day-detail-modal .ant-modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #eaedf3;\n  background-color: #f8f9fa;\n}\n\n.day-detail-modal .ant-modal-body {\n  padding: 0;\n}\n\n.day-detail-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.day-detail-modal .ant-modal-close-x {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n/* Modal Title */\n.day-modal-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.day-date {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333333;\n  margin-right: 12px;\n}\n\n.day-pod {\n  font-size: 14px;\n  color: #666666;\n  background-color: #f0f7ff;\n  padding: 4px 12px;\n  border-radius: 16px;\n  display: inline-block;\n}\n\n.day-summary {\n  display: flex;\n  gap: 16px;\n}\n\n.summary-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.summary-label {\n  font-size: 14px;\n  color: #666666;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n}\n\n/* Modal Content */\n.modal-content {\n  padding: 24px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.search-input {\n  width: 300px;\n  border-radius: 8px;\n}\n\n.export-button {\n  border-radius: 8px;\n  background-color: #f0f7ff;\n  color: #3B82F6;\n  border-color: #d0e1fd;\n}\n\n.export-button:hover {\n  background-color: #e0efff;\n  color: #2563eb;\n  border-color: #b0d0fc;\n}\n\n/* Table Styles */\n.client-table {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.client-table .ant-table-thead > tr > th {\n  background-color: #f8f9fa;\n  color: #333333;\n  font-weight: 600;\n}\n\n.client-row-day:hover > td {\n  background-color: #f0f7ff !important;\n}\n\n.case-count {\n  font-weight: 600;\n  color: #3B82F6;\n}\n\n.amount {\n  font-weight: 600;\n  color: #10B981;\n}\n\n.summary-row {\n  background-color: #f8f9fa;\n  font-weight: 600;\n}\n\n.summary-row td {\n  padding: 12px 16px !important;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 0;\n  gap: 16px;\n}\n\n.loading-container p {\n  color: #666666;\n  margin-top: 12px;\n}\n\n/* Empty State */\n.empty-data {\n  padding: 60px 0;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .day-modal-title {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .day-summary {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .modal-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .search-input {\n    width: 100%;\n  }\n}\n\n.modality-breakdown {\n    min-width: 300px;\n    padding: 12px;\n}\n\n.modality-section {\n    margin-bottom: 16px;\n}\n\n.modality-section:last-child {\n    margin-bottom: 0;\n}\n\n.modality-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #eaedf3;\n    margin-bottom: 8px;\n}\n\n.discount-splits {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.discount-row {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr;\n    font-size: 13px;\n    padding: 4px 8px;\n    background-color: #f8f9fa;\n    border-radius: 4px;\n}\n\n.discount-row span:last-child {\n    text-align: right;\n    color: #2563eb;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
